import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import PopularAndNew from './pages/PopularAndNew';
// import Action from './pages/Action';
// import Comedy from './pages/Comedy';
// import Horror from './pages/Horror';
// import Romance from './pages/Romance';
// import Documentary from './pages/Documentary';
// import NowPlaying from './pages/NowPlaying';
// import Popular from './pages/Popular';
// import TvTopRated from './pages/TvTopRated';
// import TvAiringToday from './pages/TvAiringToday';
// import TvOnAir from './pages/TvOnAir';
// import TvPopular from './pages/TvPopular';
// import UpComing from './pages/UpComing';
// import Trending from './pages/Trending';
// import TvDocumentaries from './pages/TvDocumentaries';
// import TopRated from './pages/TopRated';
// import KidsAndFamily from './pages/KidsAndFamily';
import Movies from './pages/Movies';
import TvShows from './pages/TvShows';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import TvCategory from './pages/TvCategory';
import MovieCategory from './pages/MovieCategory';
import SearchResults from './pages/SearchResults';
import Help from './pages/Help';
import IdleBanner from './components/IdleBanner/IdleBanner';
import SurpriseMe from './pages/SurpriseMe';

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/new-and-popular" exact element={<PopularAndNew />} />
          <Route path="/help" exact element={<Help />} />
          {/* <Route path="/action" exact element={<Action />} />
          <Route path="/comedy" exact element={<Comedy />} />
          <Route path="/horror" exact element={<Horror />} />
          <Route path="/romance" exact element={<Romance />} />
          <Route path="/documentaries" exact element={<Documentary />} />
          <Route path="/now-playing" exact element={<NowPlaying />} />
          <Route path="/popular" exact element={<Popular />} />
          <Route path="/popular-and-new" exact element={<PopularAndNew />} />
          <Route path="/tv-shows-airing-today" exact element={<TvAiringToday />} />
          <Route path="/tv-shows-on-air" exact element={<TvOnAir />} />
          <Route path="/popular-tv-shows" exact element={<TvPopular />} />
          <Route path="/top-rated-tv-shows" exact element={<TvTopRated />} />
          <Route path="/upcoming-movies" exact element={<UpComing />} />
          <Route path="/trending" exact element={<Trending />} />
          <Route path="/tv-documentaries" exact element={<TvDocumentaries />} />
          <Route path="/top-rated-movies" exact element={<TopRated />} />
          <Route path="/kids-and-family" exact element={<KidsAndFamily />} /> */}
          <Route path="/movies" exact element={<Movies />} />
          <Route path="/tv-shows" exact element={<TvShows />} />
          <Route path="/login" exact element={<Login />} />
          <Route path="/sign-up" exact element={<SignUp />} />
          <Route path="/tv/:tvSlug" exact element={<TvCategory />} />
          <Route path="/movies/:movieSlug" exact element={<MovieCategory />} />
          <Route path="/search-result" exact element={<SearchResults />} />
          <Route path="/surprise-me" exact element={<SurpriseMe />} />
        </Routes>
      </Router>
      <IdleBanner />

    </div>
  );
}

export default App;
